import ScrollView from "@/baseComponents/ScrollView";
import React from "react";
import NavItem, { NavItemData } from "./NavItem";

interface NavTabProps {
  activeKey: string;
  onItemClick: (item: NavItemData) => void;
  onDoubleClick?: (item: NavItemData) => void;
  navItems: NavItemData[];
  children?: any;
}

export default function NavTab({
  activeKey,
  onItemClick,
  onDoubleClick,
  navItems,
  children
}: NavTabProps) {
  return (
    <div className="focus-nav no-draggable" style={{ margin: "5px 0" }}>
      <ScrollView className="scroll-view view-container" nohorizontal="true">
        {navItems.map((item, index) => {
          let isActive = item.path && activeKey?.startsWith?.(item.path);
          if (item?.uuid) {
            isActive = activeKey === item?.uuid;
          }
          return (
            <NavItem
              key={index}
              navName={item.navName}
              active={isActive}
              {...item}
              onClick={() => {
                onItemClick(item);
              }}
              onDoubleClick={() => {
                onDoubleClick?.(item);
              }}
            />
          );
        })}
        {children ? children : null}
      </ScrollView>
    </div>
  );
}
